import { AxiosError } from "axios";
import axiosInstance from "../app/axios";
import {
  CityPricing,
  CityPricingChanges,
  CityPricingFilters,
  CityPricingPage,
  CityPricingPayload,
  FareSimulationRequest,
  FareSimulationResponse,
  InternationalPricingApiError,
  RegionalPricing,
  RegionalPricingChanges,
  RegionalPricingKey,
} from "../shared/dtos/internationalPricingDTO";

const readHeaders = { "x-hide-success": true };

export const getRegionalPricing = async (): Promise<RegionalPricing[]> => {
  const response = await axiosInstance.get("regional-pricing", {
    headers: readHeaders,
  });
  return response.data;
};

export const updateRegionalPricing = async (
  regionKey: RegionalPricingKey,
  changes: RegionalPricingChanges,
): Promise<RegionalPricing> => {
  const response = await axiosInstance.patch(
    `regional-pricing/${regionKey}`,
    changes,
    { headers: readHeaders },
  );
  return response.data;
};

export const getCityPricing = async (
  filters: CityPricingFilters,
): Promise<CityPricingPage> => {
  const response = await axiosInstance.get("city-pricing", {
    params: filters,
    headers: readHeaders,
  });
  return response.data;
};

export const getCityPricingById = async (
  id: number,
): Promise<CityPricing> => {
  const response = await axiosInstance.get(`city-pricing/${id}`, {
    headers: readHeaders,
  });
  return response.data;
};

export const createCityPricing = async (
  payload: CityPricingPayload,
): Promise<CityPricing> => {
  const response = await axiosInstance.post("city-pricing", payload);
  return response.data;
};

export const updateCityPricing = async (
  id: number,
  changes: CityPricingChanges,
): Promise<CityPricing> => {
  const response = await axiosInstance.patch(`city-pricing/${id}`, changes);
  return response.data;
};

export const estimateSimulationFare = async (
  payload: FareSimulationRequest,
): Promise<FareSimulationResponse> => {
  const response = await axiosInstance.post(
    "fare/estimate/simulation",
    payload,
    { headers: readHeaders },
  );
  return response.data;
};

export const parseInternationalPricingError = (
  error: unknown,
): InternationalPricingApiError => {
  const axiosError = error as AxiosError<InternationalPricingApiError>;
  const data = axiosError.response?.data;
  return {
    message: data?.message || "No se pudo completar la solicitud.",
    status: axiosError.response?.status ?? data?.status,
    errors: data?.errors,
  };
};
